type SwymApi = {
  initializeActionButtons: (selector: string) => void;
};

declare global {
  interface Window {
    _swat?: SwymApi;
    SwymCallbacks?: Array<(...args: unknown[]) => void>;
  }
}

const ROOT_SELECTOR = "[data-ss-recommendations-root]";
const CARD_SELECTOR = ".card-wrapper.product-card-wrapper";

const initSwym = (selector: string): void => {
  const run = () => window._swat?.initializeActionButtons(selector);
  if (window._swat?.initializeActionButtons) run();
  else (window.SwymCallbacks = window.SwymCallbacks || []).push(run);
};

document.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach((root) => {
  const id = root.dataset.ssSectionId;
  if (!id) return;

  const selector = `[data-ss-section-id="${id}"]`;
  if (root.querySelector(CARD_SELECTOR)) return initSwym(selector);

  const observer = new MutationObserver(() => {
    if (!root.querySelector(CARD_SELECTOR)) return;
    observer.disconnect();
    initSwym(selector);
  });

  observer.observe(root, { childList: true, subtree: true });
});
